import { SettingsLayout } from '../admin'
import { InvoiceTable, OrganisationTable, SubscriptionTable, SquizTable, TeamTable, TenantTable, UserTable } from './tables'

export const Tenant = ({ goBack }) => {
  return (
    <SettingsLayout
      gap={32}
      fullWidth
      onBackButtonClick={goBack}
      title="Overview"
      hideScrollBarGutters
      px={8}
    >
      <TenantTable />
      <SubscriptionTable />
      <InvoiceTable />

      <UserTable />
      <OrganisationTable />
      <TeamTable />

      <SquizTable />
    </SettingsLayout>
  )
}